export default __webpack_public_path__ + "static/media/bike.0d8fbb74.png";